import React from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';

class WorkoutLogSeriesList extends React.Component {
  arrow = ({ text, className }) => {
    return (
      <div
        className={className}
      >{text}</div>
    );
  };

  prepareExerices = (sets, exerciseId) => {
    const ArrowLeft = this.arrow({ text: '<', className: 'arrow-prev' });
    const ArrowRight = this.arrow({ text: '>', className: 'arrow-next' });
    return(
      <ScrollMenu
        alignCenter={false}
        wrapperClass="exercise-info"
        wheel={true}
        itemClass="item-style"
        hideArrows={true}
        arrowDisabledClass="arrow-disabled-class"

        data={
          sets.map((set, index) => {
            return (
              <span key={index}>
                {set[`${exerciseId}`].weight}k x {set[`${exerciseId}`].reps}r <br/> Set {index+1}
              </span>
            );
          })
        }
        arrowLeft={ArrowLeft}
        arrowRight={ArrowRight}
      />
    );
  }

  render() {
    let { values, showSeriesForm } = this.props;
    let { series } = values;
    return (
      <div className="workout-series-list workout-log-list">
        <ul>
          {
            series.map((seriesElement, index) => {
              return !!seriesElement.exercises.length && (
                <li key={seriesElement.id}>
                  <div className="workout-item">
                    <i className="fas fa-dumbbell"></i>
                    <div className="workout-info">
                      <h4>
                        <div className="link-cursor-style" onClick={ e => {
                          showSeriesForm(index)
                        }}>
                          {seriesElement.name}
                        </div>
                      </h4>
                      <p>{ seriesElement.is_custom_reps ?
                            `${seriesElement.reps} reps` :
                            seriesElement.method
                      }, {seriesElement.setsNum} sets</p>

                        {
                          !!seriesElement.exercises.length &&
                          !Object.keys(seriesElement.sets[0][`${seriesElement.exercises[0].id}`]).length && (
                              <ul className="series-details">
                              {
                                seriesElement.exercises.map(exercise => {
                                  return(
                                    <li>
                                      {exercise.name}
                                    </li>
                                  )
                                })
                              }
                            </ul>
                          )
                        }
                    </div>
                    {
                      !!seriesElement.exercises.length &&
                      !!Object.keys(seriesElement.sets[0][`${seriesElement.exercises[0].id}`]).length && (
                          <ul className="series-details">
                          {
                            seriesElement.exercises.map(exercise => {
                              return(
                                <li className="list-element-margin">
                                  {exercise.name}
                                  {
                                    this.prepareExerices(seriesElement.sets, exercise.id)
                                  }
                                </li>
                              )
                            })
                          }
                        </ul>
                      )
                    }
                  </div>
                </li>
              );
            })
          }
        </ul>
      </div>
    );
  }
}



export default WorkoutLogSeriesList;
